// mixin also is in root folder!
export default {
  data() {
    return {
      tomaAgencys: [
        'Interhome - HHD AG',
        'Interchalet - HHD AG',
        'DanCenter A/S',
        'TUI Ferienhaus / Belvilla AG',
        'Belvilla',
        'DER Touristik Frankfurt GmbH & Co. KG',
        'I.D. Riva Tours GmbH',
        'NOVASOL AS',
      ],
    };
  },
  computed: {
    oiMixin_displayedObjectNumber() {
      /** Interhome (8695): AObjektNr
          Interchalet (93168): AObjektNr (Anmerkung: Im Feld "AObjektNr2" ist die alte Interchalet-Objektnummer)
          Dancenter (8610): AObjektNr oder AObjektNr2 (identische Werte)
          TUI Ferienhaus (433050): AObjektNr (Anmerkung: Im Feld "AObjektNr2" ist die Wohneinheit)
          Belvilla (9118): AObjektNr oder AObjektNr2 (identische Werte)
          Dertour (36691): AObjektNr (Anmerkung: Im Feld "AObjektNr2" steht immer "TOUR")
          I.D. Riva (85828): AObjektNr2
          Novasol (8757): AObjektNr2
        */
      // console.log('this.objectDataInternal.agencyName', this.objectDataInternal);
      const isTomaAgency = (this.objectDataInternal?.agencyName && this.tomaAgencys.indexOf(this.objectDataInternal.agencyName.value) > -1);
      // return objectDataInternal.agencyNumer if TOMA-Veranstalter, otherwise show e-domizil objectNumber
      return isTomaAgency ? `${this.objectDataInternal.agencyObjectNumber.value}` : `${this.objectNumber}`;
    },
  },
};
